import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

import EpimedLogoImage from '../../assets/images/sponsors/logo_epimed.svg';
import LogicLogoImage from '../../assets/images/sponsors/logo_logic.svg';
import useTranslation from '../../hooks/useTranslation';
import EpFormSelect from '../EpFormSelect';

const EpGlobalFooter = ({
  login, handleChangeLanguage, languageOptions, languageDefaultOption,
}) => {
  const [mQuery, setMQuery] = useState({
    matches: window.innerWidth < 1045,
  });

  const EndorsedBy = useTranslation('Endorsed by');
  const PoweredBy = useTranslation('Powered by');
  const Select = useTranslation('Select');

  // Atuliza o estado MQuery quando ele chega no tamanho 1045px
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1045px)');

    mediaQuery.addListener(setMQuery);
    return () => mediaQuery.removeListener(setMQuery);
  }, []);

  const loginFooter = (
    <div className="sponsors login-page__sponsors col-12">
      <ul className="sponsors__list">
        <li className="sponsors__list-item">
          <span className="sponsors__list-item-description">{EndorsedBy}</span>
          <a data-testid="sponsors__list-item-logo--LOGIC" href="https://www.icubenchmarking.com/" rel="noopener noreferrer" target="_blank">
            <img className="sponsors__list-item-logo" alt="" src={LogicLogoImage} />
          </a>
        </li>

        <li className="sponsors__list-item">
          <span className="sponsors__list-item-description">{PoweredBy}</span>
          <a data-testid="sponsors__list-item-logo--Epimed-Solutions" href="https://www.epimedsolutions.com/" rel="noopener noreferrer" target="_blank">
            <img className="sponsors__list-item-logo" alt="" src={EpimedLogoImage} />
          </a>
        </li>
      </ul>
    </div>
  );

  const mediaQueryFooter = () => (
    <>
      { (mQuery && mQuery.matches) && (
        <div className="global-footer__media-wrapper">
          {loginFooter}
          <div className="global-footer__form-select-wrapper">
            <EpFormSelect
              selectOptions={languageOptions}
              inputId="select--language"
              placeholderText={Select}
              inputName="language"
              selectDefaultValue={languageDefaultOption}
              customClass="global-footer__language-select"
              onChangeFunc={values => handleChangeLanguage(values)}
            />
          </div>
        </div>
      )}
    </>
  );
  return (
    <footer className="global-footer">
      {login ? loginFooter
        : mediaQueryFooter()}
    </footer>

  );
};

export default EpGlobalFooter;

EpGlobalFooter.defaultProps = {
  login: false,
  handleChangeLanguage: null,
  languageDefaultOption: null,
  languageOptions: null,

};

EpGlobalFooter.propTypes = {
  login: PropTypes.bool,
  handleChangeLanguage: PropTypes.func,
  languageOptions: PropTypes.arrayOf(PropTypes.object),
  languageDefaultOption: PropTypes.objectOf(PropTypes.string),

};
